import { useEffect } from 'react'
import { useRateConvert } from '@web/walter-lib/stream'
import { useBaseCurrency } from './useBaseCurrency'
import { USD_CURRENCY_CODE, USDT_CURRENCY_CODE } from '~constants/currency'
import { useCommonCMSConfig } from '~api'

interface Props {
    currencyCode?: string
}

export const useFiatMockRate = ({ currencyCode }: Props) => {
    const { data, isValidating: isCmsLoading } = useCommonCMSConfig()
    const { isStableFiat } = data?.features ?? {}
    const rateConvert = useRateConvert()
    const { calculatedBaseCurrency } = useBaseCurrency()
    const hasRate = Boolean(currencyCode && rateConvert?.getRate(calculatedBaseCurrency, currencyCode))

    useEffect(() => {
        if (!isStableFiat || isCmsLoading || !currencyCode || hasRate) {
            return
        }

        if (currencyCode === USD_CURRENCY_CODE && calculatedBaseCurrency === USDT_CURRENCY_CODE) {
            rateConvert?.setRate(calculatedBaseCurrency, currencyCode, { open: 1, close: 1 })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currencyCode, calculatedBaseCurrency, isCmsLoading, isStableFiat, hasRate])

    return {
        isMockedFiat:
            isStableFiat && currencyCode === USD_CURRENCY_CODE && calculatedBaseCurrency === USDT_CURRENCY_CODE,
    }
}
